// ! Styles

import '../../legend.css';
import '../../main.css';
import '../../main-desktop.css';
import '../../icons.css';

// ! Navbar

import {
    closeNavbar,
    attachDropdownListeners
} from '../navbar/navbar';

import '../navbar/navbar';

$(window).on("load", function() {
    $('#fwv-navbar-id').load("navbar.html", function() {
        attachDropdownListeners();
    });
})